module.exports = __webpack_public_path__ + "static/media/SCREEN_SIZEVIEW.94fe4ada.svg";